document.addEventListener('DOMContentLoaded', function() {
  const menuLinks = document.querySelectorAll('.open-side-menu');
  const body = document.body;

  menuLinks.forEach(function(link) {
      link.addEventListener('click', function(e) {
          e.preventDefault();
          const menuId = link.getAttribute('data-menu-id');
          const overlayId = link.getAttribute('data-overlay-id');
          openSideMenu(menuId, overlayId);
      });
  });

  function openSideMenu(menuId, overlayId) {
      const sideMenu = document.getElementById(menuId);
      const overlay = document.getElementById(overlayId);
      sideMenu.classList.add('open');
      overlay.classList.add('active');
      body.classList.add('side-menu-open');

      overlay.addEventListener('click', function() {
          closeSideMenu(menuId, overlayId);
      });

      sideMenu.querySelectorAll('.close-side-menu').forEach(function(button) {
          button.addEventListener('click', function() {
              closeSideMenu(menuId, overlayId);
          });
      });
  }

  function closeSideMenu(menuId, overlayId) {
      const sideMenu = document.getElementById(menuId);
      const overlay = document.getElementById(overlayId);
      sideMenu.classList.remove('open');
      overlay.classList.remove('active');
      body.classList.remove('side-menu-open');
  }
});